
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Header from "./Components/Header";


function App() {
  return (
    <>
      <Header />
      
    </>
  );
}

export default App;
